const disabled = true

export const rolesColumns = [
  {
    checkboxSelection: true,
    headerName: 'RolesManagement.RolesColumn.Name',
    headerTooltip: 'RolesManagement.RolesColumn.Name',
    field: 'roleName',
    colId: 'name',
    hide: false,
    filter: 'agTextColumnFilter',
    suppressSizeToFit: true,
    cellClass: 'modal-link-layout'
  },
  {
    headerName: 'RolesManagement.RolesColumn.Desc',
    headerTooltip: 'RolesManagement.RolesColumn.Desc',
    field: 'description',
    colId: 'description',
    hide: false,
    filter: 'agTextColumnFilter',
    suppressSizeToFit: true
  }
]
